<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
  mounted() {
    // 避免重复加载（例如热更新时）
    if (window.$crisp) return;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = 'aaef650a-de87-40ec-acd6-29d1c884d26a';

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);
  }
};
</script>

<style>
/* 全局样式已在 global.css 中定义 */
</style>